import React from "react";

/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const HostedExchange = () => {
    const heading = `HOSTED EXCHANGE`;
    const details = `Empower your team with a secure and enterprise Hosted Exchange service, purpose-built for your business.`;

    const overview = [
        `DETASAD Hosted Exchange leverages our expertise in managing Microsoft products, as well as our enterprise-grade standards in operating Microsoft corporate messaging infrastructure to deliver a world-class email service.`,
        `DETASAD handles the management, patching, security and maintenance and administration of its hosted Exchange server infrastructure which effectively helps in reducing your team’s IT workload. Instead of managing the email service, your team can now focus on core strategic initiatives that drive your business ahead.`
    ];

    const advantages = [
        [
            `Improved Security`,
            `DETASAD packs its Hosted Exchange service with enterprise grade security layers to protect your data and ensure that end-users do not worry about spam and malwares reaching their systems.`,
            icon
        ],
        [
            `Hosted in Saudi Arabia`,
            `With DETASAD Hosted Exchange, rest assure that your data stays protected within Kingdom of Saudi Arabia.`,
            icon
        ],
        [
            `Guaranteed Uptime`,
            `We know how downtime impacts your productivity and your business. That's why we back our Hosted Exchange service with an unmatched Network Uptime Guarantee and SLA.`,
            icon
        ],
        [
            `Built-in HA & DR`,
            `DETASAD Hosted Exchange is highly available and has a built-in disaster recovery, relieving you of the stress of ensuring business continuity.`,
            icon
        ]
    ];

    const functions = [
        [
            `Customizable Mailbox Sizes`,
            [
                `Each user gets a customizable size of storage, starting with 20GB. With this size of mailbox, you do not have to worry about the storage consumption for your mailboxes anymore.`
            ]
        ],
        [
            `Non-Disruptive Migration Services`,
            [
                `DETASAD provides onboarding and non-disruptive migration services (live-migration), ensuring that your email data is moved securely to DETASAD’s Hosted Exchange servers. We will help you move and adopt our Exchange.`
            ]
        ],
        [
            `Managed Email Security`,
            [
                `DETASAD Hosted Exchange comes with a managed email security service, which filters all your emails through vigorous security check using our enterprise-grade email security appliances. The security of the DETASAD Hosted Exchange is further enhanced with the managed anti-spam services which removes your hassle of removing unnecessary junk and spam emails.`
            ]
        ],
        [
            `Self-Service Portal`,
            [
                `DETASAD hosted Exchange comes with a self-service portal allowing you an access to your tenant’s resources with the ability to create new Exchange objects as per your requirements.`
            ]
        ],
        [
            `Outlook 2016 Support`,
            [
                `DETASAD Hosted Exchange supported Outlook 2016 as well as Active-Sync 2016, giving you the advantage of using the latest and top-of-the-line collaboration applications.`
            ]
        ],
        [
            `24x7x365 Support Services`,
            [
                `One of the aspects distinguishing DETASAD Hosted Exchange service is its customer support. With a 24x7x365 support service, the DETASAD Cloud team provides a distinctive and remarkable customer experience.`
            ]
        ]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-collab"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default HostedExchange;
